import { render, staticRenderFns } from "./AuthenticationModal.vue?vue&type=template&id=ecb61052&"
import script from "./AuthenticationModal.vue?vue&type=script&lang=js&"
export * from "./AuthenticationModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AuthenticationModal.vue"
export default component.exports